// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 122 ? "intro" : chunkId) + "." + {"122":"f1c22b48","587":"f1c22b48"}[chunkId] + ".chunk.css";
};